import React, { memo, useMemo } from 'react';
import { MenuItem } from 'primereact/menuitem';
import { PanelMenu } from 'primereact/panelmenu';
import './AdminMenu.css';
import { useNavigate } from 'react-router-dom';

const Adminmenu = () => {
  const navigate = useNavigate();

  const items = useMemo<MenuItem[]>(
    () => {
      const createMenuItem = (label: string, icon: string, path?: string): MenuItem => ({
        label,
        icon,
        command: path ? () => navigate(path) : undefined,
        template: (item, options) => (
          <a {...options} data-testid={`admin-menu-${label.toLowerCase().replace(/\s+/g, '-')}`}>
            <span className={item.icon}></span>
            <span className="ml-2">{item.label}</span>
          </a>
        )
      });

      return [
        createMenuItem('Dashboard', 'pi pi-fw pi-palette', '/adashboard'),
        createMenuItem('Donor', 'pi pi-users', '/donor'),
        createMenuItem('Fund Manager', 'pi pi-fw pi-user', '/fundmanager'),
        createMenuItem('Organization', 'pi pi-fw pi-users', '/org'),
        createMenuItem('Countries', 'pi pi-fw pi-map', '/country'),
        createMenuItem('Need Type', 'pi pi-fw pi-map', '/needs')
      ];
    },
    [navigate]
  );

  return (
    <aside className="main-sidebar">
      <div className="menu">
        <div className="font-bold border-round flex align-items-center justify-content-center">
          <PanelMenu model={items} />
        </div>
      </div>
    </aside>
  );
};

export default memo(Adminmenu);
